import styled from 'styled-components'
import { AIWidgetEmbed } from '@containers/AIWidgetEmbed'

interface Props {
  /** Custom AI iframe requests sheet narrow/wide via postMessage; parent handles toggle. */
  onToggleEmbedWidth?: () => void
  /** Custom AI iframe requests the panel to close via postMessage. */
  onClose?: () => void
  isExpanded?: boolean
  removeDividerSideRadius?: boolean
}

export const AIHelpContent: React.FC<Props> = ({
  onToggleEmbedWidth,
  onClose,
  isExpanded,
  removeDividerSideRadius = false
}) => {
  return (
    <ContentWrapper $removeDividerSideRadius={removeDividerSideRadius}>
      <AIWidgetEmbed
        onToggleEmbedWidth={onToggleEmbedWidth}
        onClose={onClose}
        isExpanded={isExpanded}
        supportsToggleWidth={!!onToggleEmbedWidth}
        removeDividerSideRadius={removeDividerSideRadius}
      />
    </ContentWrapper>
  )
}

const ContentWrapper = styled.div<{ $removeDividerSideRadius: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: ${({ theme, $removeDividerSideRadius }) =>
    $removeDividerSideRadius ? 0 : `${theme.borderRadius.md}rem`};
  border-bottom-left-radius: ${({ theme, $removeDividerSideRadius }) =>
    $removeDividerSideRadius ? 0 : `${theme.borderRadius.md}rem`};
  background: ${({ theme }) => theme.colors.neutralWhite};
`
